import { render, staticRenderFns } from "./blocking-settings.vue?vue&type=template&id=24514b10&scoped=true&lang=pug"
import script from "./blocking-settings.vue?vue&type=script&lang=js"
export * from "./blocking-settings.vue?vue&type=script&lang=js"
import style0 from "./blocking-settings.vue?vue&type=style&index=0&id=24514b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24514b10",
  null
  
)

export default component.exports